<template>
  <validation-observer ref="formValidator">
    <div class="p-3 filter-container">
      <div :class="`d-flex justify-content-between ${itemsContainerClass}`">
        <slot name="prior"></slot>
        <div
          v-for="filter in filters"
          :key="filter.name"
          class="item-flex"
          :class="`flex-grow-${filter.grow || 1} ${filter.class}`"
        >
          <ValidationProvider
            v-slot="{ errors }"
            :rules="filter.validations"
          >
            <div class="custom-ddf">
              <component
                :is="filter.component"
                :value="
                  models[filter.name] && !filter.mapParentValue
                    ? models[filter.name]
                    : filter.value
                "
                :class-container="filter.classContainer"
                :fieldname="filter.fieldName"
                :fieldkey="filter.fieldKey"
                :options="filter.options"
                :placeholder="filter.placeholder"
                :mask-type="filter.maskType"
                :masked="filter.masked != undefined ? filter.masked : false"
                :error="filter.error && errors[0] ? filter.error : errors[0]"
                :custom-error-msg.sync="
                  filter.error && errors[0] ? filter.error : errors[0]
                "
                :type="filter.type"
                :i="filter.icon"
                :icon="filter.icon"
                :left-icon="filter.leftIcon"
                :label="filter.label"
                :clearable="filter.clearable"
                :disabled="filter.disabled"
                :variant="filter.variant"
                @input="changeValue(filter.name, $event)"
                @change="changeValue(filter.name, $event)"
              />
            </div>
          </ValidationProvider>
        </div>
        <div :class="`item-flex ${actionsContainerClass}`">
          <action-button
            v-if="displayAdvanced"
            :class="{ transparent: !advanced }"
            i="fal fa-sliders-v"
            class="mr-2 pl-3"
            variant="orange"
            @click="advanced = !advanced"
          />

          <action-button
            :disabled="disableButton"
            text="Buscar"
            :i="iconButton"
            variant="success"
            @click="search"
          />
        </div>
      </div>

      <div v-if="advanced" class="col-md-12">
        <div class="row py-3">
          <div class="col-md-12">
            <span class="separator">FILTROS</span>
          </div>
        </div>

        <div :class="`d-flex flex-wrap justify-content-between`">
          <div
            v-for="filter in filtersContent"
            :key="filter.name"
            class="item-flex"
            :class="
              `child-flex flex-grow-${filter.grow || 1} ${filter.class || ''}`
            "
          >
            <ValidationProvider v-slot="{ errors }" :rules="filter.validations">
              <div class="custom-ddf">
                <component
                  :is="filter.component"
                  :value="
                    models[filter.name] && !filter.mapParentValue
                      ? models[filter.name]
                      : filter.value
                  "
                  :class-container="filter.classContainer"
                  :icon="filter.icon"
                  :left-icon="filter.leftIcon"
                  :fieldname="filter.fieldName"
                  :fieldkey="filter.fieldKey"
                  :options="filter.options"
                  :placeholder="filter.placeholder"
                  :mask-type="filter.maskType"
                  :masked="filter.masked != undefined ? filter.masked : false"
                  :error="filter.error && errors[0] ? filter.error : errors[0]"
                  :custom-error-msg.sync="
                    filter.error && errors[0] ? filter.error : errors[0]
                  "
                  :type="filter.type"
                  :i="filter.icon"
                  :clearable="filter.clearable"
                  :disabled="filter.disabled"
                  :label="filter.label"
                  :variant="filter.variant"
                  @input="changeValue(filter.name, $event)"
                  @change="changeValue(filter.name, $event)"
                />
              </div>
            </ValidationProvider>
          </div>
        </div>
      </div>
    </div>
  </validation-observer>
</template>

<script>
import { ValidationObserver } from 'vee-validate';
import ActionButton from '@/components/common/ActionButton';
import CustomDropDown from '@/components/common/CustomDropDown';
import CustomDatePicker from '@/components/common/CustomDatePicker';
import CustomInput from '@/components/common/CustomInput';

export default {
  name: 'FilterCustomManager',
  components: {
    ValidationObserver,
    ActionButton,
    CustomDropDown,
    CustomDatePicker,
    CustomInput,
  },
  props: {
    filtersHeader: {
      type: Array,
      default: () => [],
    },
    filtersContent: {
      type: Array,
      default: () => [],
    },
    disableButton: {
      type: Boolean,
      default: () => false,
    },
    openAdvanced: {
      type: Boolean,
      default: () => false,
    },
    displayAdvanced: {
      type: Boolean,
      default: () => true,
    },
    itemsContainerClass: {
      type: String,
      default: () => '',
    },
    actionsContainerClass: {
      type: String,
      default: () => '',
    },
    iconButton: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      advanced: this.openAdvanced,
      models: {},
    };
  },
  methods: {
    async search() {
      let isValid = await this.$refs.formValidator.validate();
      this.$emit('search', isValid ? this.models : null);
    },
    changeValue(key, data) {
      this.models[key] = data;
      this.$emit(key, data);
    },
  },
  computed: {
    filters() {
      return this.filtersHeader.filter(x => x.visible !== false);
    },
  },
  watch: {
    openAdvanced(nw) {
      this.advanced = nw;
    },
  },
};
</script>

<style scoped>
.parent-flex {
  display: flex;
  flex-wrap: wrap;
}

.child-flex {
  flex: 1 0 21%;
}

/* FILTER CONTAINER */
.filter-container {
  background: #f4f6f3 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
}
/* SEPARATOR */
.separator {
  display: flex;
  align-items: center;
  text-align: center;
  color: #aab7b1;
  font: 900 14px/17px Lato;
}
.separator::before,
.separator::after {
  content: '';
  flex: 1;
  border-bottom: 1px solid #aab7b1;
}
.separator::before {
  margin-right: 0.5em;
}
.separator::after {
  margin-left: 0.5em;
}
/* CUSTOM DROPDOWN */
.custom-ddf :placeholder-shown,
.custom-ddf .vs__search::placeholder {
  color: #495057;
  opacity: 0.8;
  line-height: 1.6;
}

.btn-setting-off {
  background-color: #f4f6f3;
  border-radius: 4px;
  border: 0px !important;
  color: #3f5b60;
}

.search-bar {
  background: #f4f6f3 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
}

.title-divider {
  border: 0.5px solid #b5c3bc;
  opacity: 1;
}
.title-content {
  background: #3f5b60 0% 0% no-repeat padding-box;
  border-radius: 21px;
  opacity: 1;
  text-align: center;
  font: Bold 17px/23px Lato;
  letter-spacing: 0;
  color: #ffffff;
}
.filter-content {
  font: Bold 14px/17px Lato;
  letter-spacing: 0;
  color: #aab7b1;
  opacity: 1;
}

.item-flex {
  margin: 10px 1%;
}

@media screen and (max-width: 1180px) {
  .d-flex {
    flex-direction: column;
  }

  .item-flex {
    width: 100%;
    margin-top: 2%;
  }

  .filter-label {
    margin: 15%;
  }

  .action-buttons {
    margin-top: 2%;
  }

  .d-flex div[class*='col-'] {
    flex: 0;
    max-width: 100%;
  }
}
</style>
